import React, { useState } from "react"
import axios from "axios"

const Subscribe = () => {
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [errors, setErrors] = useState()
  const [message, setMessage] = useState()
  const [isLoading, setLoading] = useState(false)

  const handleChange = e => {
    const { value, name } = e.target
    if (name === "firstName") {
      setFirstName(value)
    }
    if (name === "lastName") {
      setLastName(value)
    }
    if (name === "email") {
      setEmail(value)
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (firstName === "" || lastName === "" || email === "") {
      setErrors("Todos los campos son requeridos")
      setMessage()
    }
    const body = {
      firstName,
      lastName,
      email,
    }
    try {
      setLoading(true)
      setMessage()
      setErrors()
      await axios.post("https://pagos.navidadpyme.cl/subscribe", body)
      setMessage("Ya estas inscrito. Gracias!")
      setErrors()
      setLoading(false)
      setFirstName("")
      setLastName("")
      setEmail("")
    } catch (e) {
      console.log(e)
      setMessage()
      setErrors("Hubo un problema. Intenta más tarde.")
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        id="firstName"
        name="firstName"
        placeholder="Nombre"
        required
        className="mb-4 border-2 border-gray-700 py-2 px-4 rounded-full w-full focus:outline-none focus:border-pink-500"
        value={firstName}
        onChange={handleChange}
      />
      <input
        type="text"
        id="lastName"
        name="lastName"
        placeholder="Apellido"
        required
        className="mb-4 border-2 border-gray-700 py-2 px-4 rounded-full w-full focus:outline-none focus:border-pink-500"
        value={lastName}
        onChange={handleChange}
      />
      <input
        type="email"
        id="email"
        name="email"
        placeholder="Email"
        required
        className="mb-4 border-2 border-gray-700 py-2 px-4 rounded-full w-full focus:outline-none focus:border-pink-500"
        value={email}
        onChange={handleChange}
      />
      {errors && <p className="text-red-500">{errors}</p>}
      {message && <p className="text-green-500">{message}</p>}
      <button
        disabled={isLoading}
        type="submit"
        className="bg-pink-500 rounded-full py-2 px-8 text-white"
      >
        {isLoading ? "Espera un momento" : "Enviar"}
      </button>
    </form>
  )
}

export default Subscribe
